import { useRef, useState, useEffect } from 'react';
function useElementOnScreen(
  ref,
  rootMargin = "0px",
  once,
) {
  const [isIntersecting, setIsIntersecting] = useState(true);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return isIntersecting;
}

export default function AnimateIn({delay = 500, time, children, className = '', key, once=false}) {
  const ref = useRef(null);
  const onScreen = useElementOnScreen(ref, '0px', once);

  const [isInit,setIsinit]=useState(false);
  useEffect(() => {
    if(!onScreen) return
    const timer = setTimeout(() => {
      setIsinit(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [onScreen]);

  return (
    <div
      ref={ref}
      key={key}
      className={className}
      style={{
        opacity: (isInit&&onScreen) ? 1 : 0,
        translate: (isInit&&onScreen) ? "none" : "0 5rem",
        transition: `${time || "1000"}ms ease-in-out`,
      }}
    >
      {children}
    </div>
  );
};
